export function WhatsAppMock() {
  return (
    <div className="w-full max-w-[320px] bg-[#ECE5DD] rounded-lg p-3 shadow-card">
      <div className="inline-flex items-center gap-1 px-2 py-0.5 bg-violet-100 text-violet-700 rounded-full text-[10px] font-semibold mb-2 font-mono tracking-wide">
        <svg className="w-2.5 h-2.5" viewBox="0 0 16 16" fill="currentColor" aria-hidden="true">
          <path d="M8 0L9.5 4.5L14 6L9.5 7.5L8 12L6.5 7.5L2 6L6.5 4.5Z" />
        </svg>
        Drafted by Mela
      </div>

      <div className="bg-white px-3.5 py-2.5 rounded-xl rounded-tl-sm max-w-[88%] mb-2 shadow-[0_1px_1px_rgba(0,0,0,0.05)]">
        <div className="text-[12px] leading-snug text-ink-900 font-gujarati" lang="gu">
          નમસ્તે સ્નેહા, વાઇબ્રન્ટ ગુજરાતમાં મુલાકાત માટે આભાર.
        </div>
        <div className="text-[10px] text-ink-600 italic mt-1">
          “Hi Sneha, thanks for visiting at Vibrant Gujarat.”
        </div>
        <div className="text-[9px] text-ink-500 text-right mt-1 font-mono">2:34 PM</div>
      </div>

      <div className="bg-[#DCF8C6] px-3.5 py-2.5 rounded-xl rounded-tr-sm max-w-[88%] ml-auto shadow-[0_1px_1px_rgba(0,0,0,0.05)]">
        <div className="text-[12px] leading-snug text-ink-900" lang="gu">
          તમે પૂછેલા cotton blends ની વિગતો — MOQ 500, 14 દિવસમાં ready 📦
        </div>
        <div className="text-[9px] text-ink-500 text-right mt-1 font-mono">2:34 PM ✓✓</div>
      </div>
    </div>
  );
}
